<template>
  <div class="stock-details">
    <b-container fluid>
      <div v-if="skeletonloading">
        <b-row class="p-3">
          <b-col lg="8" md="8">
            <Skeleton height="9rem" width="100%" class="mt-5"></Skeleton>
          </b-col>
          <b-col lg="4" md="4">
            <Skeleton height="7rem" width="100%" class="mb-5"></Skeleton>
            <Skeleton height="5rem" width="100%" class="mb-2"></Skeleton>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="8" md="8">
            <Skeleton height="20rem" width="100%" class="mt-3"></Skeleton>
          </b-col>
          <b-col lg="4" md="4">
            <div class="details-card">
              <Skeleton height="1rem" width="40%" class="mb-2"></Skeleton>
              <b-row>
                <b-col lg="6" md="6" v-for="item in 4">
                  <div class="quickcreatecard p-0">
                    <Skeleton height="100%" width="100%" class="mb-5"></Skeleton>
                    <Skeleton height="100%" width="100%" class="mb-5"></Skeleton>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="!skeletonloading">
        <b-row class="p-3">
          <b-col lg="8" md="8">
            <b-row>
              <b-col v-if="StoreDetails">
                <b-row>
                  <b-col class="detail-border-bottom">
                    <h6 class="common-heading2">
                      {{ $t("StoreMasterDetails.title") }}
                    </h6>
                  </b-col>
                  <b-col class="detail-border-bottom">
                    <h6 class="light-txt detail-card-time">
                      As on {{ currenttime }}
                    </h6>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <div class="details-card-width1 disp-com">
                    <div>
                      <span class="details-card-heading">{{
                        $t("StoreMasterDetails.ItemsInfo.Value")
                      }}</span>
                      <p class="details-card-bold-number">
                        {{ StoreDetails ? StoreDetails.TotalValue : 0 }}
                      </p>
                    </div>
                  </div>
                  <div class="details-card-width2 disp-com">
                    <div class="details-border-left">
                      <span class="details-card-heading">{{
                        $t("StoreMasterDetails.ItemsInfo.Available")
                      }}</span>
                      <p class="details-card-bold-number">
                        {{ StoreDetails ? StoreDetails.TotalQuantity : 0 }}
                      </p>
                    </div>
                  </div>
                  <div class="details-card-width2 disp-com">
                    <div class="details-border-left">
                      <span class="details-card-heading">{{
                        $t("StoreMasterDetails.ItemsInfo.lowStock")
                      }}</span>
                      <p class="details-card-bold-number">
                        {{ StoreDetails ? StoreDetails.LowStock : 0 }}
                      </p>
                    </div>
                  </div>
                  <div class="details-card-width2 disp-com">
                    <div class="details-border-left">
                      <span class="details-card-heading">{{
                        $t("StoreMasterDetails.ItemsInfo.NotMoving")
                      }}</span>
                      <p class="details-card-bold-number">
                        {{ StoreDetails ? StoreDetails.NonMoving : 0 }}
                      </p>
                    </div>
                    <div class="display-card-list">
                      <div class="px-1">
                        <div class="details-card-heading1">&#9679; >200d</div>
                        <div class="details-card-heading1">&#9679; >100d</div>
                        <div class="details-card-heading1">&#9679; >20d</div>
                      </div>
                      <div>
                        <div class="details-card-content">
                          {{ StoreDetails ? StoreDetails.NonMoving200 : 0 }}
                        </div>
                        <div class="details-card-content">
                          {{ StoreDetails ? StoreDetails.NonMoving100 : 0 }}
                        </div>
                        <div class="details-card-content">
                          {{ StoreDetails ? StoreDetails.NonMoving50 : 0 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="details-card-width2 disp-com">
                    <div class="details-border-left">
                      <span class="details-card-heading">{{ $t("StoreMasterDetails.title") }} > 1L</span>
                      <p class="details-card-bold-number">
                        {{ StoreDetails ? StoreDetails.TotalAmountCount : 0 }}
                      </p>
                    </div>
                    <div class="display-card-list">
                      <div class="px-1">
                        <div class="details-card-heading">&#9679; >5L</div>
                        <div class="details-card-heading">&#9679; >2L</div>
                        <div class="details-card-heading">&#9679; >1L</div>
                      </div>
                      <div>
                        <div class="details-card-content">
                          {{ StoreDetails ? StoreDetails.OneLakhCount : 0 }}
                        </div>
                        <div class="details-card-content">
                          {{ StoreDetails ? StoreDetails.TwoLakhCount : 0 }}
                        </div>
                        <div class="details-card-content">
                          {{ StoreDetails ? StoreDetails.FiveLakhCount : 0 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </b-row>
                <b-row>
                  <div class="ht-space stk-det-bg6">
                    {{ StoreDetails ? StoreDetails.TotalExpiry : 0 }}
                    {{ $t("StoreMasterDetails.ItemsInfo.expire") }}
                  </div>
                  <div class="ht-space stk-det-bg5">
                    <span class="light-txt">&#65124;</span><span class="light-txt me-2">60d</span>
                    <span class="details-card-content1">{{
                      StoreDetails ? StoreDetails.Expiry60 : 0
                    }}</span>
                  </div>
                  <div class="ht-space stk-det-bg4">
                    <span class="light-txt">&#65124;</span><span class="me-2 light-txt">45d</span>
                    <span class="details-card-content1">{{
                      StoreDetails ? StoreDetails.Expiry45 : 0
                    }}</span>
                  </div>
                  <div class="ht-space stk-det-bg3">
                    <span class="light-txt">&#65124;</span><span class="me-2 light-txt">30d</span>
                    <span class="details-card-content1">{{
                      StoreDetails ? StoreDetails.Expiry30 : 0
                    }}</span>
                  </div>
                  <div class="ht-space stk-det-bg2">
                    <span class="light-txt">&#65124;</span><span class="me-2 light-txt">14d</span>
                    <span class="details-card-content1">{{
                      StoreDetails?.Expiry14
                    }}</span>
                  </div>
                  <div class="ht-space stk-det-bg1">
                    <span class="light-txt">&#65124;</span><span class="me-2 light-txt">7d</span>
                    <span class="details-card-content1">{{
                      StoreDetails?.Expiry7
                    }}</span>
                  </div>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                <label class="display-field-label">{{
                  "Transfer In(Pending)"
                }}</label>
              </b-col>
              <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                <div class="store-badges">
                  <div class="store-badge ss-badge" @click="inboundIssue()">
                    <span class="badge-label"></span>
                    <span class="badge-count">{{
                      StoreDetails?.InboundIssueCount
                    }}</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                <label class="display-field-label">{{
                  "Transfer Out(Pending)"
                }}</label>
              </b-col>
              <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                <div class="store-badges">
                  <div class="store-badge ss-badge" @click="outboundIssue()">
                    <span class="badge-label"></span>
                    <span class="badge-count">{{
                      StoreDetails?.OutboundIssueCount
                    }}</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <storedetails :storedivdetails="StoreDetails2" />
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col>
                <MemberDetails status="0" />
              </b-col>
            </b-row> -->
          </b-col>
          <b-col lg="4" md="4">
            <b-row v-if="$route.query.storename">
              <b-col>
                <!-- <div>
                  <p class="details-card-heading2">Average Cycle time</p>
                  <h6 class="averagetime">10h 14min</h6>
                </div> -->
                <b-row>
                  <b-col class="itemissue my-4">
                    <!-- <Button label="Item Issue" severity="info" /> -->
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p v-if="substorehisarr.length != 0" class="details-card-heading2 mb-2">
                      HISTORY
                    </p>
                    <div class="historydiv">
                      <div class="d-flex align-items-center justify-content-between mb-3"
                        v-for="item in substorehisarr">
                        <div class="d-flex align-items-center gap-2">
                          <i class="pi pi-arrow-right" style="color: #999999"></i>
                          <div class="d-flex align-items-center gap-2">
                            <div class="historystorebg">
                              <p>SS</p>
                            </div>
                            <p class="historystorename">{{ item.storename }}</p>
                          </div>
                        </div>
                        <p class="totalitemamount">&#8377; {{ item.value }}</p>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-3"
                        v-for="item in depstorehisarr">
                        <div class="d-flex align-items-center gap-2">
                          <i class="pi pi-arrow-right" style="color: #999999"></i>
                          <div class="d-flex align-items-center gap-2">
                            <div class="historystorebg">
                              <p>DS</p>
                            </div>
                            <p class="historystorename">{{ item.storename }}</p>
                          </div>
                        </div>
                        <p class="totalitemamount">&#8377; {{ item.value }}</p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="details-card">
                  <p class="details-card-heading2 mb-2">Quick Create</p>
                  <b-row>
                    <b-col lg="6" md="6" v-if="$route.query.status == '1'">
                      <div class="quickcreatecard" @click="IsQuickCreate('GRN')">
                        <div class="quickimgbg">
                          <img src="../../../../assets/Img/icons/inventoryimg.png" />
                        </div>
                        <p class="quickcardheader">Create a GRN</p>
                        <p class="quickcarddesc">
                          You can manually add or import excel
                        </p>
                      </div>
                    </b-col>
                    <b-col lg="6" md="6" v-if="$route.query.status == '1'">
                      <div class="quickcreatecard" @click="IsQuickCreate('PO')">
                        <div class="quickimgbg">
                          <img src="../../../../assets/Img/icons/poconsumptionimg.png" />
                        </div>
                        <p class="quickcardheader">Create PO</p>
                      </div>
                    </b-col>
                    <b-col lg="6" md="6">
                      <div class="quickcreatecard" @click="IsQuickCreate('Consumption')">
                        <div class="quickimgbg">
                          <img src="../../../../assets/Img/icons/poconsumptionimg.png" />
                        </div>
                        <p class="quickcardheader">Record Consumption</p>
                      </div>
                    </b-col>
                    <b-col lg="6" md="6">
                      <div class="quickcreatecard" @click="IsReorder">
                        <div class="quickimgbg">
                          <img src="../../../../assets/Img/icons/checkavailabilityimg.png" />
                        </div>
                        <p class="quickcardheader">Check Reorder</p>
                        <!-- <p class="quickcarddesc">
                          You can manually add or import excel
                        </p> -->
                      </div>
                    </b-col>
                    <b-col lg="6" md="6" v-if="$route.query.status == '1'">
                      <div class="quickcreatecard" @click="IsConsigneePO">
                        <div class="quickimgbg">
                          <img src="../../../../assets/Img/icons/poconsumptionimg.png" />
                        </div>
                        <p class="quickcardheader">Consignee PO</p>
                        <!-- <p class="quickcarddesc">
                          You can manually add or import excel
                        </p> -->
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="p-3">
          <b-col lg="8" md="8"> </b-col>
          <b-col lg="4" md="4" class=""> </b-col>
        </b-row>
        <b-row>
          <b-col lg="8" md="8"> </b-col>
          <b-col lg="4" md="4"> </b-col>
        </b-row>
        <b-row>
          <b-col lg="8" md="8"> </b-col>
          <b-col lg="4" md="4"> </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
  <Dialog v-model:visible="visible" modal header="Choose how you want to create a GRN" :style="{ width: '75vw' }"
    :breakpoints="{ '960px': '75vw', '641px': '100vw' }">
    <b-row>
      <b-col sm="6" cols="12" lg="4">
        <div class="text-center grnpopup">
          <img class="grn-icon py-3" src="../../../../assets/Img/icons/with-po.svg" />
          <p class="common-heading1">{{ $t("grnpopup.withpo") }}</p>
          <p class="light-txt">
            {{ $t("grnpopup.withpocontent") }}
          </p>
          <Button @click="IsCreate('GRN With PO', 127, 453)" class="my-3 grnbtn">{{ $t("grnpopup.choose") }}</Button>
        </div>
      </b-col>
      <b-col sm="6" cols="12" lg="4">
        <div class="text-center grnpopup">
          <img class="grn-icon py-3" src="../../../../assets/Img/icons/without-po.svg" />
          <p class="common-heading1">{{ $t("grnpopup.withoutpo") }}</p>
          <p class="light-txt">
            {{ $t("grnpopup.withoutpocontent") }}
          </p>
          <Button @click="IsCreate('GRN Without PO', 128, 457)" class="my-3 grnbtn">{{ $t("grnpopup.choose") }}</Button>
        </div>
      </b-col>
      <b-col sm="6" cols="12" lg="4">
        <div class="text-center grnpopup">
          <img class="grn-icon py-3" src="../../../../assets/Img/icons/without-po.svg" />
          <p class="common-heading1">{{ $t("grnpopup.deliverychellon") }}</p>
          <p class="light-txt">
            {{ $t("grnpopup.deliverychelloncontent") }}
          </p>
          <Button @click="IsCreate('DC', 322, 995)" class="my-3 grnbtn">{{
            $t("grnpopup.choose")
          }}</Button>
        </div>
      </b-col>
    </b-row>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import storedetails from "../../../../modules/Inventory/components/MasterDetails/StoreDetails.vue";
import MemberDetails from "../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";
import StoreService from "../../../../modules/Inventory/Service/StoreService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../modules/Inventory/Service/AccessControl";
import MastersService from "../../../../modules/Inventory/Service/MastersService";

export default defineComponent({
  components: {
    storedetails,
    MemberDetails,
  },
  props: {
    dataObj: {
      type: Object,
      default: {},
    },
  },
  setup(_, { emit }) {
    const route = useRoute();
    let StoreId = ref(route.query.Id);
    let StoreBranchId = ref(route.query.BranchId);
    let status = route.query.status ?? 0;
    let Type = route.query.Type;
    let storebranchmappingid = route.query.storebranchmapid ?? 0;

    let StoreDetails: any = ref();
    let StoreDetails2: any = ref();

    let substorehisarr: any = ref([]);
    let depstorehisarr: any = ref([]);
    var today = new Date();
    let currenttime = ref();
    const visible = ref(false);
    const router = useRouter();
    const toast = useToast();
    let skeletonloading = ref(false);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    onMounted(() => {
      LoadDetails();
    });

    watch(
      () => route.query.Id,
      (newVal: any) => {
        StoreId.value = newVal;
        LoadDetails();
      }
    );

    const LoadDetails = async () => {
      debugger;
      skeletonloading.value = true;
      substorehisarr.value = [];
      depstorehisarr.value = [];
      let localhour;
      let daytype;
      let minutes;
      if (today.getHours() > 12) {
        localhour = today.getHours() - 12;
        daytype = "PM";
      } else {
        localhour = today.getHours();
        daytype = "AM";
      }

      if (today.getMinutes() > 9) {
        minutes = today.getMinutes();
      } else {
        minutes = "0" + today.getMinutes();
      }
      if (localhour < 10) {
        localhour = "0" + localhour;
      }

      currenttime.value = localhour + ":" + minutes + " " + daytype;

      const response = await StoreService.getStoreDetailsById(
        StoreId.value,
        StoreBranchId.value,
        usersData.OrganizationId
      );
      const Secondresponse = await StoreService.GetByStoreIdAndBranchId(
        StoreId.value,
        StoreBranchId.value
      );

      StoreDetails2.value = Secondresponse["result"];
      StoreDetails.value = response["result"];

      StoreDetails.value.TotalQuantity = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.TotalQuantity
      );
      StoreDetails.value.TotalValue = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.TotalValue
      );

      if (StoreDetails.value) {
        // emit("StoreCode", StoreDetails.value.StoreDetails.Code);
        StoreDetails.value["NonMoving"] =
          response["result"].NonMoving200 +
          response["result"].NonMoving100 +
          response["result"].NonMoving50;
        StoreDetails.value["TotalExpiry"] =
          response["result"].Expiry60 +
          response["result"].Expiry45 +
          response["result"].Expiry30 +
          response["result"].Expiry14 +
          response["result"].Expiry7;

        StoreDetails.value["TotalAmountCount"] =
          response["result"].OneLakhCount +
          response["result"].TwoLakhCount +
          response["result"].FiveLakhCount;
        // for (const [storename, value] of Object.entries(
        //   response["result"].SubStoredata
        // )) {
        //   let valueamount = Number(value);
        //   if (valueamount > 0) {
        //     substorehisarr.value.push({ storename, value });
        //   }
        // }
        // for (const [storename, value] of Object.entries(
        //   response["result"].DepStoredata
        // )) {
        //   let valueamount = Number(value);
        //   if (valueamount > 0) {
        //     depstorehisarr.value.push({ storename, value });
        //   }
        // }
      }
      StoreDetails.value.NonMoving = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.NonMoving
      );
      StoreDetails.value.LowStock = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.LowStock
      );
      StoreDetails.value.NonMoving100 = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.NonMoving100
      );
      StoreDetails.value.NonMoving200 = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.NonMoving200
      );
      StoreDetails.value.NonMoving50 = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.NonMoving50
      );
      StoreDetails.value.TotalExpiry = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.TotalExpiry
      );
      StoreDetails.value.Expiry60 = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.Expiry60
      );
      StoreDetails.value.Expiry45 = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.Expiry45
      );
      StoreDetails.value.Expiry30 = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.Expiry30
      );
      StoreDetails.value.Expiry14 = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.Expiry14
      );
      StoreDetails.value.Expiry7 = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.Expiry7
      );
      StoreDetails.value.OneLakhCount = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.OneLakhCount
      );
      StoreDetails.value.TwoLakhCount = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.TwoLakhCount
      );
      StoreDetails.value.FiveLakhCount = Intl.NumberFormat("en-IN").format(
        StoreDetails.value.FiveLakhCount
      );

      skeletonloading.value = false;
    };
    let functionRights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    const IsQuickCreate = async (data) => {
      let InstantEntityId: any = {
        EntityId: 0,
      };
      if (data == "GRN") {
        InstantEntityId.EntityId = 3045;
      } else if (data == "PO") {
        InstantEntityId.EntityId = 3044;
      } else if (data == "Consumption") {
        InstantEntityId.EntityId = 3027;
      }

      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));

      const response = await MastersService.CheckMenuRights(
        InstantEntityId.EntityId,
        rolesData.RoleId
      );

      console.log(response["result"]);

      let Rights = ref({
        Create: false,
        Update: false,
        Read: false,
        Delete: false,
      });

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          functionRights.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          functionRights.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          functionRights.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          functionRights.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      functionRights.value.EntityId = InstantEntityId.EntityId;
      functionRights.value.Create = Rights.value.Create;
      functionRights.value.Update = Rights.value.Update;
      functionRights.value.Read = Rights.value.Read;
      functionRights.value.Delete = Rights.value.Delete;

      let permissionResult: any = checkPermission(Rights, "Add");

      if (permissionResult.hasPermission) {
        if (data == "GRN") {
          visible.value = true;
        } else if (data == "PO") {
          router.push({
            name: "POCreation",
            query: {
              formId: 1020,
              doctype: "4",
              param: "PO",
              StockTransId: "0",
              StoreId: StoreId.value,
              status: Type,
              OperationId: functionRights.value.CreateId,
              EntityId: functionRights.value.EntityId,
              storebranchmapid: Number(route.query.storebranchmapid ?? 0),
              BranchId: route.query.BranchId ?? 0,
              IsZeroBill: route.query.IsZeroBill,
              IsDraft: 1,
            },
          });
        } else if (data == "Consumption") {
          router.push({
            name: "Consumption",
            query: {
              StoreId: StoreId.value,
              status: status,
              Type: Type,
              OperationId: functionRights.value.CreateId,
              EntityId: functionRights.value.EntityId,
              BranchId: StoreBranchId.value,
            },
          });
        }
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    const ParamValues = ref({
      requestId: "",
      Id: 0,
      Type: 0,
      DocNo: 0,
      StockTransId: 0,
      storebranchmapid: 0,
      type: 1,
      SupplierId: 0,
      StoreId: 0,
      status: "",
    });

    ParamValues.value.Id = Number(StoreId.value);
    ParamValues.value.StoreId = Number(StoreId.value);
    ParamValues.value.storebranchmapid = Number(storebranchmappingid);

    ParamValues.value.Type = Number(status);
    ParamValues.value.status = String(Type);

    const IsCreate = (val, EntityId, OperationId) => {
      router.push({
        name: "grn",
        query: {
          param: val,
          StoreId: ParamValues.value.Id,
          status: ParamValues.value.Type,
          Type: ParamValues.value.status,
          OperationId: OperationId,
          EntityId: EntityId,
          storebranchmapid: Number(route.query.storebranchmapid ?? 0),
          BranchId: Number(route.query.BranchId ?? 0),
          IsZeroBill: route.query.IsZeroBill ?? "false",
          IsDraft: 1,
        },
      });
    };
    const IsReorder = () => {
      router.push({
        name: "reOrderLevelBasedPO",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "reOrder",
        },
      });
    };

    const IsConsigneePO = () => {
      debugger;
      router.push({
        name: "ConsigneePO",
        query: {
          param: "ConsigneePO",
          StoreId: StoreId.value,
          BranchId: StoreBranchId.value,
          storebranchmapid: storebranchmappingid,
        },
      });
    };
    function inboundIssue() {
      debugger;

      const TabIndex = {
        Indexval: 4,
      };
      localStorage.removeItem("TabIndex");
      localStorage.setItem("TabIndex", JSON.stringify(TabIndex));

      const EntityData = {
        EntityId: 3050,
      };
      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(EntityData));

      //localStorage.removeItem("EntityData");
      localStorage.setItem("TransferFlag", JSON.stringify(1));

      router.push({
        path: "/StoreTabDetails",
        query: {
          Id: StoreId.value,
          Type: Type,
          status: status,
          storename: route.query.storename,
          storebranchmapid: storebranchmappingid,
          BranchId: StoreBranchId.value,
        },
      });

      emit("itemIssue");
    }

    function outboundIssue() {
      debugger;

      const TabIndex = {
        Indexval: 4,
      };

      const SubTabIndex = {
        Indexval: 1,
      };

      localStorage.removeItem("TabIndex");
      localStorage.setItem("TabIndex", JSON.stringify(TabIndex));

      localStorage.removeItem("ItemIssueSubTabIndex");
      localStorage.setItem("ItemIssueSubTabIndex", JSON.stringify(SubTabIndex));

      const EntityData = {
        EntityId: 3048,
      };
      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(EntityData));

      //localStorage.removeItem("EntityData");
      localStorage.setItem("TransferFlag", JSON.stringify(1));

      router.push({
        path: "/StoreTabDetails",
        query: {
          Id: StoreId.value,
          Type: Type,
          status: status,
          storename: route.query.storename,
          storebranchmapid: storebranchmappingid,
          BranchId: StoreBranchId.value,
        },
      });

      emit("itemIssue");
    }

    return {
      IsReorder,
      IsConsigneePO,
      status,
      StoreDetails,
      StoreDetails2,
      substorehisarr,
      depstorehisarr,
      currenttime,
      visible,
      IsCreate,
      IsQuickCreate,
      skeletonloading,
      inboundIssue,
      outboundIssue,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../../../assets/variables.scss";

.stock-details {
  height: 79vh;
  overflow: auto;

  b-container {
    width: 100%;
  }
}

.disp-com {
  line-height: 30px;
}

// .details-card {
//     background-color: #FFFFFF;
//     border-radius: 0px;
// }

.detail-card-item {
  background: #f8f9fe;
  border-radius: 6px;
  padding: 6px 12px;
  margin-left: 15px;
}

.detail-card-time {
  background: #f8f9fe;
  border-radius: 6px;
  padding: 6px 12px;
  float: right;
}

.detail-border-bottom {
  border-bottom: 1px solid #e1e1e1;
}

.details-card-heading {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;

  font-size: 11px;
  color: #999999;
  word-break: keep-all;
}

.details-card-heading1 {
  font-size: 12px;
  color: #999999;
}

.details-card-heading2 {
  font-size: 13px;
  color: #999999;
}

.details-card-content {
  font-size: 11px;
  font-weight: 500;
}

.details-card-content1 {
  font-size: 14px;
  font-weight: 500;
}

.details-card-bold-number {
  font-size: 18px;
  font-weight: 600;
}

.details-card-bold-number span {
  color: #4b9e65;
  padding: 5px 7px;
  border-radius: 5px;
  background-color: #e7f8f0;
  font-size: 14px;
}

.details-card-width1 {
  width: 22%;
}

.details-card-width2 {
  width: 18%;
}

.details-border-left {
  border-left: 1px solid #e1e1e1;
  padding-left: 15px;
}

.display-card-list {
  display: flex;
}

.red-blk-info {
  width: 100% !important;
  padding: 0px !important;
  margin: 0px !important;
}

.ht-space {
  height: 70px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stk-det-bg1 {
  background-color: #fa7a81;
  width: 12%;
}

.stk-det-bg2 {
  background-color: #fa9399;
  width: 12%;
}

.stk-det-bg3 {
  background-color: #fca3a8;
  width: 12%;
}

.stk-det-bg4 {
  background-color: #f8b6ba;
  width: 12%;
}

.stk-det-bg5 {
  background-color: #fddbdd;
  width: 12%;
}

.stk-det-bg6 {
  background-color: #fdedee;
  width: 40%;
}

.details-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.details-innercircle {
  border-radius: 50%;
  background-color: #cdd0fb;
  padding: 7px;
}

.details-outercircle {
  border-radius: 20px;
  background-color: #feecde;
  padding: 9px;
}

.averagetime {
  font-size: 25px;
  color: #444444;
}

.itemissue .p-button {
  background-color: $AddButton !important;
  border: none !important;
  font-size: 14px;
  white-space: nowrap;
  width: 100%;
}

.historystorename {
  font-size: 14px;
}

.totalitemamount {
  font-size: 14px;
  font-weight: 500;
}

.historydiv {
  max-height: 300px;
  height: auto;
}

.historystorebg {
  background-color: #ffcccc;
  padding: 5px 7px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  width: max-content;

  p {
    font-size: 12px;
  }
}

.quickcreatecard {
  padding: 10px;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  margin: 10px 0px;
  height: 110px;
}

.quickimgbg {
  border: 1px solid #e1e1e1;
  border-radius: 50%;
  padding: 3px 5px;
  width: max-content;
  background-color: #f7f7f7;
}

.quickcardheader {
  font-weight: 500;
  font-size: 14px;
}

.quickcarddesc {
  font-size: 12px;
  color: #999999;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media only screen and (max-width: 767px) {
  .details-card-width1 {
    width: 50%;
    border: 1px solid #e1e1e1;
    margin-top: 15px;
  }

  .details-card-width2 {
    width: 25%;
    border: 1px solid #e1e1e1;
    margin-top: 15px;
  }

  .details-border-left {
    border-left: none;
    margin-top: 15px;
  }

  .stk-det-bg6 {
    width: 75%;
  }

  .stk-det-bg5,
  .stk-det-bg4,
  .stk-det-bg3,
  .stk-det-bg2,
  .stk-det-bg1 {
    width: 25%;
  }
}

@media only screen and (max-width: 576px) {
  .details-card-bold-number[data-v-ada2194a] {
    font-size: 14px;
    font-weight: 600;
  }

  .details-card-width1 {
    width: 50%;
  }

  .details-card-width2 {
    width: 50%;
  }

  .detail-card-item {
    display: block;
    margin-left: 0px;
  }

  .display-field-label {
    font-size: 14px;
    color: #666666;
    margin-bottom: 0;
  }

  .badge-count {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }

  .store-badges {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-top: 4px;
  }
}
</style>
